import React, { useRef, useEffect } from "react";
import { useField } from "@unform/core";

const InputSelect = ({ label, name, ...rest }) => {
	const inputRef = useRef(null);
	const { fieldName, registerField, defaultValue, error } = useField(name);

	useEffect(() => {
		registerField({
			name: fieldName,
			ref: inputRef.current,
			path: "value",
			setValue(ref, value) {
				ref.value = value;
			},
			clearValue(ref) {
				ref.value = "";
			},
		});
	}, [fieldName, registerField]);

	return (
		<label>
			<p>{label}</p>
			<select ref={inputRef} defaultValue={defaultValue} {...rest}>
				<option value=''>Selecione estado</option>
				<option value='AC'>Acre</option>
				<option value='AL'>Alagoas</option>
				<option value='AP'>Amapá</option>
				<option value='AM'>Amazonas</option>
				<option value='BA'>Bahia</option>
				<option value='CE'>Ceará</option>
				<option value='DF'>Distrito Federal</option>
				<option value='ES'>Espírito Santo</option>
				<option value='GO'>Goiás</option>
				<option value='MA'>Maranhão</option>
				<option value='MT'>Mato Grosso</option>
				<option value='MS'>Mato Grosso do Sul</option>
				<option value='MG'>Minas Gerais</option>
				<option value='PA'>Pará</option>
				<option value='PB'>Paraíba</option>
				<option value='PR'>Paraná</option>
				<option value='PE'>Pernambuco</option>
				<option value='PI'>Piauí</option>
				<option value='RJ'>Rio de Janeiro</option>
				<option value='RN'>Rio Grande do Norte</option>
				<option value='RS'>Rio Grande do Sul</option>
				<option value='RO'>Rondônia</option>
				<option value='RR'>Roraima</option>
				<option value='SC'>Santa Catarina</option>
				<option value='SP'>São Paulo</option>
				<option value='SE'>Sergipe</option>
				<option value='TO'>Tocantins</option>
			</select>
			{error && <span className='require'>{error}</span>}
		</label>
	);
};

export default InputSelect;
